import actionTypes from "./GCMOMOIR02ActionType";

/**
 * 組織管理
 */
const initialState = {
    isFetching: false,
    data: [],
    isError: false,
    err_type: "",
    err_detail: [],
};

/**
 * 組織管理を更新するReducer
 * @param {*} state
 * @param {*} action
 */
export const saveOrganizationManagement = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_ORGANIZATION_MANAGEMENT_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: [],
            });
        case actionTypes.UPDATE_ORGANIZATION_MANAGEMENT_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail,
            });
        case actionTypes.UPDATE_ORGANIZATION_MANAGEMENT_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: [],
            });
        case actionTypes.UPDATE_ORGANIZATION_MANAGEMENT_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                data: {},
                err_type: "",
                err_detail: [],
            });
        default:
            return state;
    }
};
